import minhImage from "../../public/minh1.png";

function ArticleHeader2AuthorsMobile({
  date,
  thumbnail,
  title,
  description,
  note,
  secondAuthor,
  pictureSecondAuthor,
  portfolioSecondAuthor,
}: any) {
  return (
    <div className="flex flex-col gap-20 mt-12">
      <div>
        <div className="flex flex-col gap-8">
          {/* Title */}
          <div className="flex lg:max-w-[92%] flex-col gap-4 text-pretty">
            <p className="text-[26px] font-semibold leading-tight tracking-wide">
              {title}
            </p>

            {note && (
              <p className="underline underline-offset-4 text-custom-green">
                {note}
              </p>
            )}

            {description && <p className="text-gray-6">{description}</p>}
          </div>

          <div className="flex flex-col gap-3">
            <div className="flex flex-wrap items-center gap-6 mb-1">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 relative overflow-hidden rounded-full">
                  <img
                    src={minhImage}
                    alt="Minh Le"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <p className="text-[17px] leading-tight">Minh Le</p>
              </div>

              <a
                className="flex items-center gap-3"
                href={portfolioSecondAuthor}
                target="_blank"
              >
                <div className="h-10 w-10 relative overflow-hidden rounded-full">
                  <img
                    src={pictureSecondAuthor}
                    alt="Second Author"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <p className="text-[17px] leading-tight">{secondAuthor}</p>
              </a>
            </div>

            {/* Date */}
            <p className="text-gray-6">
              <time>{date}</time>
            </p>
          </div>
        </div>

        {/* Thumbnail */}
        <div className="h-8"></div>
        <img
          alt="thumbnail"
          fetchPriority="high"
          decoding="async"
          className="-ml-6 w-[calc(100%+48px)] max-w-none"
          src={thumbnail}
        />
      </div>
    </div>
  );
}

export default ArticleHeader2AuthorsMobile;
